























import Vue from "vue";
import { AreaType } from "throne-api";

import VacancyText from "@/components/vacancy-text.vue";

export default Vue.extend({
  name: "components-panel-area",
  components: {
    VacancyText,
  },
  props: {
    areaType: { type: String as () => AreaType, required: true },
    floor: { type: String, required: true },
    areaName: { type: String, required: true },
    vacantCount: { type: Number, required: true },
    totalCount: { type: Number, required: true },
    waitingSeconds: { type: Number, required: true },
    // NOTE: These 2 props below are for 3rd gen hardcoding
    placeId: { type: Number, required: false },
    status: { type: String, required: false },
  },
  computed: {
    isFull(): boolean {
      return (
        this.vacantCount === 0 ||
        ((this.vacantCount === 0 || (this.vacantCount === 1 && this.totalCount !== 1)) && this.waitingSeconds > 0)
      );
    },
  },
});
